import { render, staticRenderFns } from "./StartOverButton.vue?vue&type=template&id=cf9a8560&scoped=true"
import script from "./StartOverButton.vue?vue&type=script&lang=js"
export * from "./StartOverButton.vue?vue&type=script&lang=js"
import style0 from "./StartOverButton.vue?vue&type=style&index=0&id=cf9a8560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9a8560",
  null
  
)

export default component.exports